<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="operateBar">
        <el-button v-if="checkApi('addApp')" size="small" type="primary" @click="add">添加应用账号</el-button>
      </template>
      <template v-if="hasApi(['reviseApp','deleteApp'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('reviseApp')" type="text" @click="revise(row)">修改</el-button>
            <el-button v-if="checkApi('deleteApp')" type="text" class="danger" @click="remove(row)">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <app-operate v-if="appOperate.visible" :dialog-data="appOperate" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import AppOperate from "./dialog/AppOperate"
  import {appStatus} from "@utils/formatList"
  export default {
    name: "index",
    components: {AppOperate},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "应用名称", property: "name"},
            {label: "应用KEY", property: "app_key"},
            {label: "应用密钥", property: "app_secret"},
            {label: "状态", property: "status", format: appStatus},
            {label: "创建时间", property: "create_at"},
          ],
          api: "getAppList",
        },
        appOperate: {title: "", visible: false, row: null, width: 650},
      }
    },
    methods: {
      add() {
        this.appOperate.visible = true;
        this.appOperate.title = "添加应用账号";
        this.appOperate.row = null;
      },
      revise(row) {
        this.appOperate.visible = true;
        this.appOperate.title = "修改应用账号";
        const nv = {...row};
        nv.status = +nv.status;
        this.appOperate.row = nv;
      },
      remove(row) {
        this.openConfirm("删除该应用账号", async ()=> {
          let nv = {open_account_id: row.id};
          let res = await this.$Http.deleteApp(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
